/**
 * Customer Return Profile Store
 *
 * Manages customer return profile data including blocked status.
 *
 * @public API:
 * - customerReturnProfile: ref<Object> - Profile data { isBlockedFromReturning: Boolean }
 * - isBlockedFromReturning: computed<Boolean> - Whether customer is blocked from returns
 * - resetCustomerReturnProfile: () => void - Reset profile data
 */
export const useCustomerReturnProfileStore = defineStore('customerReturnProfile', () => {
  // ==================== State ====================

  /**
   * Customer return profile data
   * @type {import('vue').Ref<{isBlockedFromReturning: boolean} | null>}
   * @public
   */
  const customerReturnProfile = ref(null)

  // ==================== Computed ====================

  /**
   * Whether the customer is blocked from making returns
   * @type {import('vue').ComputedRef<boolean>}
   * @public
   */
  const isBlockedFromReturning = computed(() => {
    return customerReturnProfile.value?.isBlockedFromReturning || false
  })

  // ==================== Actions ====================

  /**
   * Reset customer return profile data
   * @public
   */
  const resetCustomerReturnProfile = () => {
    customerReturnProfile.value = null
  }

  // ==================== Public API ====================

  return {
    // State
    customerReturnProfile,
    // Computed
    isBlockedFromReturning,
    // Actions
    resetCustomerReturnProfile,
  }
})
